export const MonitorState = Object.freeze({
    UP: 10,
    UNKNOWN: 0,
    DOWN: -10,
});

export const CheckState = Object.freeze({
    UP: 1,
    DOWN: 0,
});

export const AlertType = Object.freeze({
    OUTAGE: 1,
    RECOVERY: 2,
    TEST: 3,
    REMINDER: 4,
    WARNING: 5,
});

export const Channels = Object.freeze({
    EMAIL: 51,
    SMS: 52,
    PHONE_CALL: 53,
});

// no longer have channels under 50
export const SkipRecoveryAlerts = [12];

export const MonitorStatus = Object.freeze({
    INACTIVE: -9,
    DISABLED: -2,
    PAUSED: -1,
    DRAFT: 0,
    ENABLED: 1,
});

export const availableLanguages = ['en', 'es'];
export const defaultLanguage = 'en';
